import { render, staticRenderFns } from "./PuzzleTemplateCreate.vue?vue&type=template&id=cdb93f02&"
import script from "./PuzzleTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./PuzzleTemplateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports